import { Model } from 'modules/core/lib/mobx-rest'

// TODO: Keeping this here to avoid circular dependencies,
// but remove it once the GraphQL migration is done
export interface IDefaultShift {
  id: string
  start_at: string
  end_at: string
  title: string
  overnight_shift: boolean
  color: string | null
  archived: boolean
  location_id: string | null | undefined
  work_area_id: string | null | undefined
  notes: string | null | null | undefined
  all_company: boolean
  visible_teams_ids: string[] | null
  visible_locations_ids: string[] | null
  extra_hours: boolean
}

class DefaultShift extends Model<IDefaultShift> {
  static urlRoot() {
    return '/shift_management/default_shifts'
  }
}

export default DefaultShift
